function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/anchor-is-valid, no-script-url */
import React from 'react';
import PropTypes from 'prop-types';
import LIGHTBULB_SVG from 'images/lightbulb.svg';
import LIGHTBULB_WHITE_SVG from 'images/lightbulb_white.svg';
import FeedbackMenuBody from 'js/containers/legacy/FeedbackMenuBody';
import { Title } from './style';

var FeedbackMenuButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FeedbackMenuButton, _React$Component);

  function FeedbackMenuButton(props) {
    var _this;

    _classCallCheck(this, FeedbackMenuButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FeedbackMenuButton).call(this, props));
    _this._launchFeedbackMenu = _this._launchFeedbackMenu.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(FeedbackMenuButton, [{
    key: "_launchFeedbackMenu",
    value: function _launchFeedbackMenu() {
      this.props.launchFeedbackModal(React.createElement(FeedbackMenuBody, null));
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "navigation-bar__login"
      }, React.createElement("a", {
        href: "javascript:void(0)",
        onClick: this._launchFeedbackMenu
      }, React.createElement("img", {
        className: "navigation-bar__login__lightbulb-icon svg--hide-until-load",
        src: this.props.dark ? LIGHTBULB_SVG : LIGHTBULB_WHITE_SVG,
        alt: this.props.feedbackMenuLinkImageAltText
      }), React.createElement("span", {
        className: "navigation-bar__login__lightbulb-icon-text"
      }, this.props.feedbackMenuLinkMainText, ' ', React.createElement(Title, {
        dark: this.props.dark
      }, 'Give us your feedback'))));
    }
  }]);

  return FeedbackMenuButton;
}(React.Component);

FeedbackMenuButton.propTypes = {
  dark: PropTypes.bool,
  launchFeedbackModal: PropTypes.func,
  feedbackMenuLinkMainText: PropTypes.string,
  feedbackMenuLinkSubText: PropTypes.string,
  feedbackMenuLinkImageAltText: PropTypes.string
};
export { FeedbackMenuButton as default };